import React from 'react';

import CardHOC from './Components/CardHOC';
import ShortText from '../../Types/Components/ShortText';

export default function (props) {
  return <CardHOC question={props.question}>
    <ShortText {...props} />
  </CardHOC>
}
